// extracted by mini-css-extract-plugin
export default {"menu":"OneEmployee_menu__KXyKD","sticky":"OneEmployee_sticky__hxOEi","placeHolderShimmer":"OneEmployee_placeHolderShimmer__IZ3P+"};